import React, {useEffect} from 'react';

import {sendDesktopAnalyticsPerSession} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {Title} from '@optimaxdev/design-system';

import {useInView} from 'react-intersection-observer';

import {TYP_BOTTOM_SECTION} from 'constants/analytics/events/typ';

import {RateUsSection} from '../rateUsSection/rateUsSection';

import {ShopCategories, ShopCategory} from './shopCategory/shopCategory';

import s from './successPageBottomSection.scss';

/**
 * Success Page bottom section
 * @return {React.ReactElement} component
 */
export const SuccessPageBottomSection = () => {
    const {inView, ref} = useInView({
        threshold: 1,
        triggerOnce: true,
    });

    useEffect(() => {
        if (inView) {
            sendDesktopAnalyticsPerSession({
                event: TYP_BOTTOM_SECTION,
                label: {action: 'Keep Shopping', label: 'CTA - Showed'},
            });
        }
    }, [inView]);

    return (
        <section className={s.section}>
            <div ref={ref}>
                <Title
                    className={s.title}
                    fontSize="24px"
                    letterSpacing="normal"
                    level={3}
                    lineHeight="34px"
                >
                    Keep Shopping
                </Title>
                <div className={s.categoryWrapper}>
                    <ShopCategory category={ShopCategories.eyeglasses} />
                    <ShopCategory category={ShopCategories.sunglasses} />
                    <ShopCategory category={ShopCategories.contacts} />
                </div>
            </div>
            <RateUsSection isRedesign />
        </section>
    );
};
